import React, { useState } from 'react';
import styles from './TextInput.module.css';

interface TextInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'number';
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  touched?: boolean;
}

export const TextInput: React.FC<TextInputProps> = ({ label, value, onChange, type = 'text', error, placeholder, disabled = false, touched }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleClear = () => {
    onChange('');
  };

  const hasValue = value.length > 0;
  const isFloating = isFocused || hasValue;

  return (
    <div className={styles.container}>
      <div className={`${styles.inputWrapper} ${error ? styles.error : ''} ${isFocused ? styles.focused : ''} ${disabled ? styles.disabled : ''}`}>
        <label className={`${styles.label} ${isFloating ? styles.floating : ''}`}>{label}</label>
        <input
          type={type}
          value={value}
          onChange={e => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={isFloating ? placeholder : ''}
          disabled={disabled}
          className={styles.input}
        />
        {hasValue && !disabled && (
          <button type="button" className={styles.clearButton} onClick={handleClear} onMouseDown={e => e.preventDefault()} aria-label="Clear input">
            ×
          </button>
        )}
      </div>
      {(touched === true || touched === undefined) && error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};
